import julesPic from "@/public/images/artists/jules.png";
import { Artist } from "@/types/types";

export const jules = {
  id: "177",
  name: "Jules",
  image: julesPic,
  description: `Jules's voice is a refined contralto with effortless clarity, marked by natural elasticity that allows her to glide seamlessly through melodic phrases. Possessing exceptional dynamic control, she transitions smoothly from soft, intimate passages to bold, soaring crescendos without losing tonal precision. Her vocal style is both agile and commanding, showcasing a mastery of technique and texture.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fjules-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Soul", "Country", "Blues", "Disco", "Unprocessed", "Deep"],
      secondary: ["Bluegrass"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "High",
      },
      specific: {
        low: 53,
        high: 73,
      },
      sweetSpot: 62,
    },
  },
} as const satisfies Artist;
